import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import Quill from 'quill';
import { Mention } from 'quill-mention';
import 'react-quill/dist/quill.snow.css';
import 'quill-mention/dist/quill.mention.css';
import style from './TextEditor.module.css';
import APIServices from 'services/APIServices';
import { selectLoader, uploadFilesToApi } from 'utils/Helpers';
// import { useAuth } from 'contexts/AuthContext';

Quill.register('modules/mention', Mention);

export default function TextEditor({ value, onChange, error, members, minimalToolbar = false, isSubtask = false, parentId = '' }) {
  // const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  // const [teamMembers, setTeamMembers] = useState([]);
  const reactQuillRef = useRef();

  useEffect(() => {
    if (reactQuillRef.current) {
      const editor = reactQuillRef.current.getEditor();
      editor.focus(); // Focus on the editor when it renders

      // Move the cursor to the end
      const length = editor.getLength();
      editor.setSelection(length, 0);
    }
  }, []);

  // useEffect(() => {
  //   if (members) {
  //     let formattedMembers = members.map((member) => ({
  //       id: member._id,
  //       value: member?.fullName,
  //       profilePic: member.profilePic
  //     }));
  //     formattedMembers = formattedMembers.filter((x) => x.id !== user?._id);

  //     // setTeamMembers(formattedMembers);
  //   }
  // }, [members, user]);

  const toolbarOptions = minimalToolbar
    ? [['bold', 'italic', 'underline', 'strike'], [{ list: 'bullet' }]]
    : [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['link', 'image'] // media
      ];

  const imageHandler = useCallback(() => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();
    input.onchange = async () => {
      if (input !== null && input.files !== null) {
        setIsLoading(true);
        try {
          const files = [...input.files];
          const formData = new FormData();
          files.forEach((file) => formData.append('attachments', file));

          const response = await uploadFilesToApi(files, isSubtask, parentId);
          //  APIServices.post('/project-milestone/upload', formData, {
          //   'Content-Type': 'multipart/form-data'
          // });
          console.log(response, "filessssssssss");
          
          if (response?.attachments?.length > 0) {
            const quill = reactQuillRef.current;
            if (quill) {
              const range = quill.getEditor().getSelection();
              range && quill.getEditor().insertEmbed(range.index, 'image', response?.[0]?.url);
            }
          }
          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);
        }
      }
    };
  }, []);

// keep regex at top level
const urlRegex = /(https?:\/\/[^\s]+)/g;

const handleLinkPreview = async (url, index) => {
  try {
    setIsLoading(true);
    const response = await APIServices.post('/link/preview', { url });

    if (response?.title) {
      const quill = reactQuillRef.current.getEditor();

      // remove the raw URL
      quill.deleteText(index, url.length);

      // insert the fetched title with link
      quill.insertText(index, response.title, { link: url });
    }
  } catch (err) {
    console.error('Error fetching link preview:', err);
  } finally {
    setIsLoading(false);
  }
};

const handleTextChange = (content, delta, source, editor) => {
  onChange(content);

  if (source === 'user') {
    const text = editor.getText();
    const matches = [...text.matchAll(urlRegex)];

    if (matches.length > 0) {
      const lastMatch = matches[matches.length - 1];
      const url = lastMatch[0];
      const index = lastMatch.index;

      // fire preview for the last typed URL
      handleLinkPreview(url, index);
    }
  }
};

  return (
    <div className={style.text_editor_wrapper}>
      {isLoading && <div className={style.text_editor_loader}>{selectLoader(60)} Fetching link…</div>}
      <ReactQuill
        theme="snow"
        className={`quill-container ${error ? 'form-invalid' : ''}`}
        ref={reactQuillRef}
        placeholder="Write a comment"
        value={value}
        onChange={handleTextChange}
        preserveWhitespace={true}
        modules={{
          toolbar: { container: toolbarOptions, handlers: { image: imageHandler } }
        }}
      />
      {error && <p className="text-danger">{error}</p>}
    </div>
  );
}
